module.exports = __webpack_public_path__ + "img/newFeatJun15.ab9b27e1.png";